module.exports = __webpack_public_path__ + "img/Slajd10.0d62ff09.jpeg";